import { getFunctions, httpsCallable } from 'firebase/functions';

export const sendFeedback = async (userType: string, comment: string, name?: string, sport?: string): Promise<void> => {
  try {
    const functions = getFunctions();
    const sendFeedbackFn = httpsCallable(functions, 'sendFeedback');
    await sendFeedbackFn({ userType, comment, name, sport });
  } catch (error) {
    console.error('Error sending feedback:', error);
    throw error;
  }
};
